module.exports = __webpack_public_path__ + "assets-cabinet/img/phone-ico.bb955472.svg";